module.exports = __webpack_public_path__ + "img/active_yb.1f12e741.png";